export const CUSTOM_RECEPTOR_ID = 'trr-custom'
